/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, ReactNode } from 'react';

interface SideNavContextType {
  isCollapsed: boolean;
  toggleCollapse: () => void;
}

const SideNavContext = createContext<SideNavContextType | undefined>(undefined);

export const useSideNav = () => {
  const context = useContext(SideNavContext);
  if (!context) {
    throw new Error('useSideNav must be used within SideNavProvider');
  }
  return context;
};

export const SideNavProvider = ({ children }: { children: ReactNode }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <SideNavContext.Provider value={{ isCollapsed, toggleCollapse }}>
      {children}
    </SideNavContext.Provider>
  );
};
